export const GET_INFO_SECTION_BOOKMARKS_INIT = 'GET_INFO_SECTION_BOOKMARKS_INIT';
export const GET_INFO_SECTION_USER_BOOKMARKS_SUCCESS = 'GET_INFO_SECTION_USER_BOOKMARKS_SUCCESS';
export const GET_MENU_SERIES_USER_BOOKMARKS_SUCCESS = 'GET_MENU_SERIES_USER_BOOKMARKS_SUCCESS';
export const GET_MENU_SERIES_BOOKMARKS_INIT = 'GET_MENU_SERIES_BOOKMARKS_INIT';
export const GET_USER_BOOKMARKS_ERROR = 'GET_USER_BOOKMARKS_ERROR';
export const CLEAR_INFO_SECTION_USER_BOOKMARK = 'CLEAR_INFO_SECTION_USER_BOOKMARK';
